var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rect',{attrs:{"width":"9","height":"9","fill":_vm.fillcolor,"transform":"translate(0, 10)","stroke":"black","stroke-width":_vm.strokewidth},on:{"click":function($event){_vm.selectpacket()}}})}
var staticRenderFns = []

export { render, staticRenderFns }